import { useEffect } from "react";
import Loading from "shared/components/Spin";

const Upsells = ({ project, onNext }) => {
  useEffect(() => {
    onNext({
      payload: {
        fields: {
          ...project.fields,
        },
      },
    });
  }, []);

  return <Loading />;
};

export default Upsells;
